<template>
  <article class="item" :style="backdrop">
    <header class="item--header">
      <h2 class="title">
        {{ item.title }} <span class="released">({{ item.originalReleaseYear }})</span>
      </h2>
      <div class="meta">
        <Genres :genres="item.genres" />
        <div class="runtime">{{ item.runtime }} min</div>
        <div class="age">{{ item.ageCertification }}</div>
      </div>
      <Ratings :ratings="item.ratings" />
    </header>
    <div class="info">
      <p class="description">{{ item.shortDescription }}</p>
      <Providers :providers="item.providers" :showOffers="true" />
      <Clips :clips="item.clips" />
    </div>

    <div class="poster"><Poster :poster="item.poster" size="s592" /></div>
  </article>
</template>

<script>
import Poster from './Poster';
import Ratings from './Ratings';
import Genres from './Genres';
import Providers from './Providers';
import Clips from './Clips';
export default {
  name: 'Item',
  components: {
    Poster,
    Ratings,
    Providers,
    Clips,
    Genres,
  },
  filters: {},
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {};
  },

  computed: {
    backdrop: function() {
      return {
        '--backdrop': this.getBackdrop(this.item),
      };
    },
  },

  methods: {
    getBackdrop: function({ backdrops }) {
      if (!backdrops) return;
      return `url(https://images.justwatch.com${backdrops[0].backdrop_url.replace('{profile}', 's1440')})`;
    },
  },
};
</script>

<style lang="scss">
:root {
  --backdrop: lightgrey;
}

.item {
  position: relative;
  background-image: linear-gradient(135deg, rgba(48, 207, 208, 0.8) 0%, rgba(51, 8, 103, 0.8) 50%), var(--backdrop);
  background-size: cover;
  background-repeat: no-repeat;
  padding: 100px 48px;
  text-shadow: 0 3px 3px rgba(0, 0, 0, 0.2);
  display: grid;
  grid-template-areas: 'header poster' 'info poster';
  @media (max-width: 720px) {
    grid-template-areas: 'header' 'poster' 'info';
  }

  .item--header {
    grid-area: header;
    .title {
      font-size: 54px;
      font-weight: 800;
      margin-bottom: 16px;
      @media (max-width: 720px) {
        font-size: 36px;
      }
    }

    .ratings {
      .rating {
        font-size: 32px;
        svg {
          width: 32px;
          height: 32px;
        }
      }
    }
  }
  .poster {
    max-width: 300px;
    margin: 48px auto;
    grid-area: poster;
    @media (max-width: 720px) {
      float: none;
    }
  }
  .meta {
    grid-area: meta;
    display: flex;
    align-items: center;

    .age {
    }
  }
  .info {
    position: relative;
    .description {
      max-width: 800px;
      font-size: 24px;
    }

    .clips {
      margin: 48px 0;
    }
  }
  .providers {
    .provider {
      max-width: none;
      .providers--icon {
        width: 70px;
      }
    }
  }
  .button {
    margin: 36px 0;
    padding: 12px 16px;
    border-radius: 16px;
    font-weight: 800;
    font-size: 24px;
    display: inline-block;
    border: 1px solid rgba(48, 207, 208, 0.8);
    background: rgba(51, 8, 103, 1);
    a {
      color: white;
    }
  }
}
</style>
